import React from "react";

const PageContainer = ({
  children,
  title,
  bgImg = "/images/standards/bg-standards.jpeg",
  className = "",
}) => {
  return (
    <main className={`site-main pb-10 min-h-[1000px] ${className}`}>
      <section>
        <div
          className="bg-cover bg-center flex justify-center items-center"
          style={{
            backgroundImage: `url(${bgImg})`,
            height: "400px",
          }}
        >
          <h2 className="text-white text-6xl">{title}</h2>
        </div>
      </section>
      {children}
    </main>
  );
};

export default PageContainer;
